/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

/**
 * Where a navigation came from, stamped into history state by the ui Link wrapper. Back
 * affordances use it to return to a list exactly as the user left it (filters, search).
 */
export type From = { pathname: string; search: string };

/** The history state that lets the page opened from here find its way back. */
export function cameFrom(location: From): { from: From } {
  return { from: { pathname: location.pathname, search: location.search } };
}

export function fromOf(state: unknown): From | null {
  if (typeof state !== "object" || state === null || !("from" in state)) {
    return null;
  }
  const from = (state as { from: unknown }).from;
  if (typeof from !== "object" || from === null) {
    return null;
  }
  const { pathname, search } = from as Record<string, unknown>;
  return typeof pathname === "string" && typeof search === "string"
    ? { pathname, search }
    : null;
}

export function backHref(to: string, state: unknown): string {
  const from = fromOf(state);
  return from !== null && from.pathname === to ? `${to}${from.search}` : to;
}
